import sortByOptions from './sortByOptions';
import { bedOptions, bathOptions } from './bedBathOptions';

export default [
  {
    name: 'city',
    label: 'Location',
    type: 'DROP_DOWN',
    optionId: 'id',
    optionName: 'name',
    optionData: 'cities',
    fieldName: 'ccz=city&city%5B%5D',
    defaultAllText: 'Any'
  },
  {
    name: 'propertyType',
    label: 'Type',
    type: 'DROP_DOWN',
    optionId: 'mlsPtID',
    optionName: 'mlsPropertyType',
    optionData: 'propertyTypes',
    fieldName: 'pt',
    defaultAllText: 'Any'
  },
  {
    name: 'sortBy',
    label: 'Sort By',
    type: 'DROP_DOWN',
    optionId: 'id',
    optionName: 'sortType',
    optionData: sortByOptions,
    fieldName: 'srt',
    lastField: true // last field in the row
  },
  {
    name: 'minBed',
    label: 'Bedrooms',
    type: 'DROP_DOWN',
    fieldName: 'bd',
    size: 'half',
    order: 0, // for half sized fields
    defaultAllText: 'Any Number',
    optionId: 'id',
    optionName: 'label',
    optionData: bedOptions
  },
  {
    name: 'minBath',
    label: 'Baths',
    type: 'DROP_DOWN',
    fieldName: 'tb',
    size: 'half',
    order: 1,
    defaultAllText: 'Any Number',
    optionId: 'id',
    optionName: 'label',
    optionData: bathOptions
  },
  {
    name: 'minPrice',
    label: 'Min Price',
    type: 'SINGLE_LINE',
    fieldName: 'lp',
    size: 'half',
    order: 0
  },
  {
    name: 'maxPrice',
    label: 'Max Price',
    type: 'SINGLE_LINE',
    fieldName: 'hp',
    size: 'half',
    order: 1
  }
];
